import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="confeti".
//
// Unos segundos de confeti al aparecer el elemento: la confirmación de «Vuelve a suscribirte» en la
// página de después de la baja (US-147-2.4.2). Del diseño:
//
// - No sale con «reducir movimiento» (`prefers-reduced-motion`).
// - No tapa clics: el lienzo no recibe eventos (`pointer-events: none`) y se quita al acabar.
// - Los lectores de pantalla no lo anuncian (`aria-hidden`).
// - Los colores son los del sistema de diseño: los lee de las propiedades `--rnk-Confeti-color-*`
//   que pone la hoja de estilos (`_flujo-de-baja.scss`), para no repetir aquí ningún color.
const DURACION_MS = 5000
const PIEZAS = 180
const COLORES = 6

export default class extends Controller {
  connect () {
    this.element.closest('[tabindex]')?.focus()
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return

    const colores = this.colores()
    if (colores.length === 0) return

    this.lanza(colores)
  }

  disconnect () {
    this.lienzo?.remove()
  }

  // privados

  colores () {
    const estilos = getComputedStyle(this.element)
    return Array.from({ length: COLORES }, (_, i) => estilos.getPropertyValue(`--rnk-Confeti-color-${i + 1}`).trim())
      .filter(Boolean)
  }

  lanza (colores) {
    const lienzo = document.createElement('canvas')
    lienzo.setAttribute('aria-hidden', 'true')
    lienzo.className = 'rnk-Confeti'
    document.body.appendChild(lienzo)
    this.lienzo = lienzo

    const contexto = lienzo.getContext('2d')
    const escala = window.devicePixelRatio || 1
    const ancho = window.innerWidth
    const alto = window.innerHeight
    lienzo.width = ancho * escala
    lienzo.height = alto * escala
    contexto.setTransform(escala, 0, 0, escala, 0, 0)

    const piezas = Array.from({ length: PIEZAS }, (_, i) => {
      const izquierda = i % 2 === 0
      return {
        x: izquierda ? 0 : ancho,
        y: alto * 0.6,
        vx: (izquierda ? 1 : -1) * (4 + Math.random() * 9),
        vy: -(9 + Math.random() * 10),
        giro: Math.random() * Math.PI,
        vgiro: (Math.random() - 0.5) * 0.3,
        w: 6 + Math.random() * 6,
        h: 8 + Math.random() * 8,
        color: colores[i % colores.length]
      }
    })

    const inicio = performance.now()
    const paso = (ahora) => {
      contexto.clearRect(0, 0, ancho, alto)
      let quedan = 0
      piezas.forEach(pieza => {
        pieza.vy += 0.35
        pieza.vx *= 0.99
        pieza.x += pieza.vx
        pieza.y += pieza.vy
        pieza.giro += pieza.vgiro
        if (pieza.y > alto + 20) return

        quedan++
        contexto.save()
        contexto.translate(pieza.x, pieza.y)
        contexto.rotate(pieza.giro)
        contexto.fillStyle = pieza.color
        contexto.fillRect(-pieza.w / 2, -pieza.h / 2, pieza.w, pieza.h)
        contexto.restore()
      })
      if (quedan && ahora - inicio < DURACION_MS) {
        requestAnimationFrame(paso)
      } else {
        lienzo.remove()
      }
    }
    requestAnimationFrame(paso)
  }
}
